export default __webpack_public_path__ + "static/media/pengxinwei_logo.92211974.png";